import GenericPage from '../components/generic/GenericPage'
import tiles from '../components/generic/Tiles'

const MapNC = () => {
  return (
    <GenericPage frame="https://rsgiskaznu.maps.arcgis.com/apps/mapviewer/index.html?webmap=09c809fd13964f059cbb455f23681655" title="Карта устойчивости природных комплексов" tiles={tiles.back('map')} frame_offset={60}/>
  )
}
export default MapNC
